import mickey from "../../assets/images/menu/disney/mickey.png";
import minnie from "../../assets/images/menu/disney/minnie.png";
import donald from "../../assets/images/menu/disney/donald.png";
import pluto from "../../assets/images/menu/disney/pluto.png";
import goofy from "../../assets/images/menu/disney/goofy.png";
import daisy from "../../assets/images/menu/disney/daisy.png";
import appIcon from "../../assets/images/menu/disneyWeb/clubApp.png";
import eventIcon from "../../assets/images/menu/event.svg";
import listenIcon from "../../assets/images/menu/listen-active.svg";
import watchIcon from "../../assets/images/menu/watch-active.svg";
import playingIcon from "../../assets/images/menu/playing-active.svg";
import storyIcon from "../../assets/images/menu/storyIcon.svg";
import { MenuItemType } from "../../types";

export type DisneyCharacter =
  | "donald"
  | "minnie"
  | "daisy"
  | "mickey"
  | "pluto"
  | "goofy";

type MenuItemData = {
  type: MenuItemType | null;
  image: string;
  icon: string | null;
};

export const menuItemData: Record<DisneyCharacter | "clubApp", MenuItemData> = {
  donald: {
    type: "event",
    image: donald,
    icon: eventIcon,
  },
  minnie: {
    type: "listen",
    image: minnie,
    icon: listenIcon,
  },
  mickey: {
    type: "watch",
    image: mickey,
    icon: watchIcon,
  },
  pluto: {
    type: "playing",
    image: pluto,
    icon: playingIcon,
  },
  goofy: {
    type: "story",
    image: goofy,
    icon: storyIcon,
  },
  daisy: {
    type: "bedtime",
    image: daisy,
    icon: listenIcon,
  },
  clubApp: {
    type: null,
    image: appIcon,
    icon: null,
  },
};

export const menuItemStyles: {
  [key: string]: string;
} = {
  bubbleWidth: "size-[152px] shrink-0 tablet-lg:size-[240px]",
  charactorWidth: "size-24 tablet-lg:size-[144px]",
  fontSize: "text-[17px]",
  iconSize: "size-5 tablet-lg:size-6",
  emptyBubble: "size-[100px] shrink-0 tablet-lg:size-[160px]",
};

export const slotCharacters = (hasBedtime: boolean): DisneyCharacter[] =>
  hasBedtime
    ? ["donald", "minnie", "daisy", "mickey", "pluto", "goofy"]
    : ["donald", "minnie", "mickey", "pluto", "goofy"];

export const slotDelay = (index: number) => `${index * 0.3}s`;

export const menuLayout: {
  [key: string]: string;
} = {
  bubbleGroup: "relative mx-auto flex w-fit flex-col pb-6",
  bubbleRow1:
    "ml-[26px] flex items-start gap-2 tablet-lg:ml-[72px] tablet-lg:gap-4",
  bubble2: "mt-12 tablet-lg:mt-24",
  bubbleRow2:
    "-mt-7 ml-[64px] flex items-start gap-[-20px] tablet-lg:-mt-14 tablet-lg:ml-[96px] tablet-lg:gap-3",
  bubble4: "mt-[116px] tablet-lg:mt-[144px]",
  bubbleRow3:
    "-mt-[108px] flex items-start tablet-lg:-mt-[128px] tablet-lg:gap-5",
  bubble6: "mt-[120px] tablet-lg:mt-[144px]",
  floatingBubble1:
    "pointer-events-none absolute left-[310px] top-10 size-10 tablet-lg:left-[520px] tablet-lg:top-[88px] tablet-lg:size-[60px]",
  floatingBubble2:
    "pointer-events-none absolute left-[6px] top-[123px] size-6 tablet-lg:left-[52px] tablet-lg:top-[208px] tablet-lg:size-9",
  floatingBubble3:
    "pointer-events-none absolute left-[324px] top-[432px] size-6 tablet-lg:left-[552px] tablet-lg:top-[644px] tablet-lg:size-9",
};
